import { useState } from "react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { messageFor, postCancel, type ProductionRow } from "../api";

export function CancelDialog({ row, open, onOpenChange, onSuccess }: { row: ProductionRow; open: boolean; onOpenChange: (open: boolean) => void; onSuccess: () => void }) {
  const [reason, setReason] = useState(""); const [error, setError] = useState<unknown>(null); const [saving, setSaving] = useState(false);
  const submit = async () => {
    if (!reason.trim()) return;
    setSaving(true); setError(null);
    try { await postCancel(row.production_key, reason.trim()); onSuccess(); onOpenChange(false); }
    catch (caught) { setError(caught); }
    finally { setSaving(false); }
  };
  return <Dialog open={open} onOpenChange={onOpenChange}><DialogContent>
    <DialogHeader><DialogTitle>Cancel {row.production_key}</DialogTitle><DialogDescription>A cancelled production disappears from this list. This cannot be undone.</DialogDescription></DialogHeader>
    {Boolean(error) && <Alert variant="destructive"><AlertDescription>{messageFor(error)}</AlertDescription></Alert>}
    <div className="space-y-1.5"><Label htmlFor="pcogs-cancel-reason">Reason</Label><Textarea id="pcogs-cancel-reason" required value={reason} onChange={(event) => setReason(event.target.value)} /></div>
    <DialogFooter><Button variant="destructive" disabled={saving || !reason.trim()} onClick={() => void submit()}>Cancel production</Button></DialogFooter>
  </DialogContent></Dialog>;
}
